import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import swal from "sweetalert";
import DataTable from "../../components/DataTable";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import {action, createItem, deleteItem, getItem} from "../../services/service";
import {t} from "i18next";
import SettingButton from "../../components/SettingButton";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import AddButton from "../../components/AddButton";
import {Context} from "../../context/SearchContext";
import {useContext} from "react";
import SearchInput from "../../components/search/SearchInput";
import {toast} from "react-toastify";
import TempDataTable from "../../components/TemDataTable";
import Loading from "../../components/loading";
import CopyButton from "../../components/CopyButton";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "table.connection.article_1", sort: true
}, {
    name: "table.connection.article_2", sort: true
}, {
    name: "name", sort: false
}, <span className="sr-only">Edit</span>,];

const bodyTable = [
    "id",
    "article1",
    "article2",
    "name",
    "actions"
];

const ConnectionLayout = () => {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const {token} = useSelector((state) => state.user);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const navigate = useNavigate();
    const ctx = useContext(Context);

    const fetchData = async () => {
        const response = await createItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: ctx.state, regex: true},
                filter: {},
            }
        );
        if (response.success) {
            setIsLoading(false);
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: index + 1,
                    article1: item.article1,
                    article2: item.article2,
                    name: `${item.product1Name}-${item.product2Name}`,
                    actions: (
                        <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                            <SettingButton onclick={(e) => onclickSetting(item)}/>
                            <CopyButton onclick={(e) => copyHandler(item.id)}/>
                            <EditButton onclick={() => onclickEdit(item.id)}/>
                            <DeleteButton onclick={() => onclickDelete(item.id)}/>
                        </div>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);


    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage, ctx.state]);

    const onclickDelete = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/${id}`;
            let res = await deleteItem(url, token);
            if (res.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                console.log(res.message);
                setIsLoading(false);
            }
        }
    };

    const onclickEdit = (id) => {
        navigate(`/connection/update/${id}`);
    };

    const copyHandler = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            const response = await action(
              `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/copy/${id}`,
              'POST',
              token
            );
            if (response.success) {
                fetchData();
                toast.success(t("action.delete_success"), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success",
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };
    const onclickSetting = (item) => {
        if (item?.id > 0) {
            navigate(`/connection/type/${item.id}`, {
                state: {item: item},
            });
        }
    };

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    return (
        <>
            {isLoading && <Loading/>}
            <div className="px-4 py-4 sm:px-6 lg:px-8">
                <div className="mb-3 sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">{t('sidebar_menu_connection')}</h1>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <AddButton title={t(`add_connection`)} url={"add"}/>
                    </div>
                </div>
                <div className="flex justify-between items-center">
                    <Select
                        setItemsPerPage={setItemsPerPage}
                        itemsPerPage={itemsPerPage}
                    />
                    <SearchInput/>
                </div>
                <TempDataTable
                    data={data.data}
                    headerTable={headerTable}
                    bodyContent={bodyTable}
                    sortFunction={sortFunction}
                />
                <Pagination
                    handlePageClick={handlePageClick}
                    pageCount={data.pageCount}
                    forcePage={forcePage}
                />
            </div>
        </>
    );
};

export default ConnectionLayout;
